import React from 'react';
import { Modal } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import './IdleWarningModal.css';

export default function IdleWarningModal() {
  const { idleWarning } = useAuth();
  if (!idleWarning) return null;

  const extended = idleWarning === 'extended';

  return (
    <Modal show centered backdrop="static" keyboard={false} size="sm" dialogClassName="idle-modal">
      <Modal.Body className={`text-center py-4 ${extended ? 'idle-modal-extended' : 'idle-modal-warning'}`}>
        <i className={`bi ${extended ? 'bi-check-circle-fill' : 'bi-exclamation-triangle-fill'}`} />
        <p className="mt-3 mb-0 fw-semibold">
          {extended
            ? 'Session extended successfully.'
            : 'Your session will expire soon due to inactivity.'}
        </p>
        {!extended && (
          <small className="text-muted">Click anywhere to stay logged in.</small>
        )}
      </Modal.Body>
    </Modal>
  );
}
